var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectAll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 1.73112C0.666016 1.36293 0.964492 1.06445 1.33268 1.06445H2.66602C3.03421 1.06445 3.33268 1.36293 3.33268 1.73112V3.06445C3.33268 3.43264 3.03421 3.73112 2.66602 3.73112H1.33268C0.964492 3.73112 0.666016 3.43264 0.666016 3.06445V1.73112Z",
    fill: "#19213E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66602 1.73112C4.66602 1.36293 4.96449 1.06445 5.33268 1.06445H6.66602C7.03421 1.06445 7.33268 1.36293 7.33268 1.73112V3.06445C7.33268 3.43264 7.03421 3.73112 6.66602 3.73112H5.33268C4.96449 3.73112 4.66602 3.43264 4.66602 3.06445V1.73112Z",
    fill: "#19213E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66602 1.73112C8.66602 1.36293 8.96449 1.06445 9.33268 1.06445H10.666C11.0342 1.06445 11.3327 1.36293 11.3327 1.73112V3.06445C11.3327 3.43264 11.0342 3.73112 10.666 3.73112H9.33268C8.96449 3.73112 8.66602 3.43264 8.66602 3.06445V1.73112Z",
    fill: "#19213E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.666 1.73112C12.666 1.36293 12.9645 1.06445 13.3327 1.06445H14.666C15.0342 1.06445 15.3327 1.36293 15.3327 1.73112V3.06445C15.3327 3.43264 15.0342 3.73112 14.666 3.73112H13.3327C12.9645 3.73112 12.666 3.43264 12.666 3.06445V1.73112Z",
    fill: "#19213E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 5.73112C0.666016 5.36293 0.964492 5.06445 1.33268 5.06445H2.66602C3.03421 5.06445 3.33268 5.36293 3.33268 5.73112V7.06445C3.33268 7.43264 3.03421 7.73112 2.66602 7.73112H1.33268C0.964492 7.73112 0.666016 7.43264 0.666016 7.06445V5.73112Z",
    fill: "#19213E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66602 5.73112C4.66602 5.36293 4.96449 5.06445 5.33268 5.06445H6.66602C7.03421 5.06445 7.33268 5.36293 7.33268 5.73112V7.06445C7.33268 7.43264 7.03421 7.73112 6.66602 7.73112H5.33268C4.96449 7.73112 4.66602 7.43264 4.66602 7.06445V5.73112Z",
    fill: "#19213E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66602 5.73112C8.66602 5.36293 8.96449 5.06445 9.33268 5.06445H10.666C11.0342 5.06445 11.3327 5.36293 11.3327 5.73112V7.06445C11.3327 7.43264 11.0342 7.73112 10.666 7.73112H9.33268C8.96449 7.73112 8.66602 7.43264 8.66602 7.06445V5.73112Z",
    fill: "#19213E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.666 5.73112C12.666 5.36293 12.9645 5.06445 13.3327 5.06445H14.666C15.0342 5.06445 15.3327 5.36293 15.3327 5.73112V7.06445C15.3327 7.43264 15.0342 7.73112 14.666 7.73112H13.3327C12.9645 7.73112 12.666 7.43264 12.666 7.06445V5.73112Z",
    fill: "#19213E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 9.73112C0.666016 9.36293 0.964492 9.06445 1.33268 9.06445H2.66602C3.03421 9.06445 3.33268 9.36293 3.33268 9.73112V11.0645C3.33268 11.4326 3.03421 11.7311 2.66602 11.7311H1.33268C0.964492 11.7311 0.666016 11.4326 0.666016 11.0645V9.73112Z",
    fill: "#19213E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66602 9.73112C4.66602 9.36293 4.96449 9.06445 5.33268 9.06445H6.66602C7.03421 9.06445 7.33268 9.36293 7.33268 9.73112V11.0645C7.33268 11.4326 7.03421 11.7311 6.66602 11.7311H5.33268C4.96449 11.7311 4.66602 11.4326 4.66602 11.0645V9.73112Z",
    fill: "#19213E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66602 9.73112C8.66602 9.36293 8.96449 9.06445 9.33268 9.06445H10.666C11.0342 9.06445 11.3327 9.36293 11.3327 9.73112V11.0645C11.3327 11.4326 11.0342 11.7311 10.666 11.7311H9.33268C8.96449 11.7311 8.66602 11.4326 8.66602 11.0645V9.73112Z",
    fill: "#19213E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.666 9.73112C12.666 9.36293 12.9645 9.06445 13.3327 9.06445H14.666C15.0342 9.06445 15.3327 9.36293 15.3327 9.73112V11.0645C15.3327 11.4326 15.0342 11.7311 14.666 11.7311H13.3327C12.9645 11.7311 12.666 11.4326 12.666 11.0645V9.73112Z",
    fill: "#19213E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 13.7311C0.666016 13.3629 0.964492 13.0645 1.33268 13.0645H2.66602C3.03421 13.0645 3.33268 13.3629 3.33268 13.7311V15.0645C3.33268 15.4326 3.03421 15.7311 2.66602 15.7311H1.33268C0.964492 15.7311 0.666016 15.4326 0.666016 15.0645V13.7311Z",
    fill: "#19213E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66602 13.7311C4.66602 13.3629 4.96449 13.0645 5.33268 13.0645H6.66602C7.03421 13.0645 7.33268 13.3629 7.33268 13.7311V15.0645C7.33268 15.4326 7.03421 15.7311 6.66602 15.7311H5.33268C4.96449 15.7311 4.66602 15.4326 4.66602 15.0645V13.7311Z",
    fill: "#19213E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66602 13.7311C8.66602 13.3629 8.96449 13.0645 9.33268 13.0645H10.666C11.0342 13.0645 11.3327 13.3629 11.3327 13.7311V15.0645C11.3327 15.4326 11.0342 15.7311 10.666 15.7311H9.33268C8.96449 15.7311 8.66602 15.4326 8.66602 15.0645V13.7311Z",
    fill: "#19213E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.666 13.7311C12.666 13.3629 12.9645 13.0645 13.3327 13.0645H14.666C15.0342 13.0645 15.3327 13.3629 15.3327 13.7311V15.0645C15.3327 15.4326 15.0342 15.7311 14.666 15.7311H13.3327C12.9645 15.7311 12.666 15.4326 12.666 15.0645V13.7311Z",
    fill: "#19213E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAll);
export default __webpack_public_path__ + "static/media/selectAll.e32193c2a3c361c9f50abd8e5dbb3cce.svg";
export { ForwardRef as ReactComponent };